import { InvoiceBillingStage } from '@features/invoices/enums/invoiceBillingStage'

import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

export const invoiceEditorVariantToBillingStage: Partial<Record<InvoiceEditorVariant, InvoiceBillingStage>> = {
  [InvoiceEditorVariant.DepositInvoiceDraftEdit]: InvoiceBillingStage.Deposit,
  [InvoiceEditorVariant.DepositInvoiceNewFromQuote]: InvoiceBillingStage.Deposit,
  [InvoiceEditorVariant.FinalInvoiceDraftEdit]: InvoiceBillingStage.Final,
  [InvoiceEditorVariant.FinalInvoiceNewFromQuote]: InvoiceBillingStage.Final,
}
